import StyledInput from 'components/styledInput/StyledInput';
import Switch from 'components/switch/Switch';
import { normalizePenibilite } from './templateFormData';
import { useRiskyPositions } from './missionTemplateRiskyPositions';

const ARTICLE_L4154_2_URL =
  'https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000035653199';
const POSITION_AT_RISK_SWITCH_ID = 'mission-template-position-at-risk';

/** Whether the position is at risk, and which pénibilité factors apply. */
const TemplateRiskSection = ({ positionAtRisk, penibilite, onChange }) => {
  const riskyPositions = useRiskyPositions();
  const selected = normalizePenibilite(penibilite);

  const togglePenibilite = (besttField) => {
    const next = { ...selected };
    if (next[besttField]) delete next[besttField];
    else next[besttField] = true;
    onChange({ position_at_risk: positionAtRisk, penibilite: next });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col">
        <span className="ft-xl font-medium text-gray-900">Poste à risque</span>
        <span className="ft-sm text-gray-500">
          Indiquez si ce poste expose l&apos;intérimaire à des risques
          particuliers.
        </span>
      </div>

      <div className="flex items-center justify-between gap-4 px-6 py-4 border border-gray-100 rounded-lg">
        <div className="flex flex-col gap-1 min-w-0">
          <label
            htmlFor={POSITION_AT_RISK_SWITCH_ID}
            className="ft-sm font-medium text-gray-900 cursor-pointer"
          >
            Ce poste figure sur la liste des postes à risques ?
          </label>
          <a
            href={ARTICLE_L4154_2_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-fit ft-sm text-gray-500 hover:underline"
          >
            Consulter l&apos;article L. 4154-2
          </a>
        </div>
        <Switch
          id={POSITION_AT_RISK_SWITCH_ID}
          checked={!!positionAtRisk}
          onChange={(checked) =>
            onChange({ position_at_risk: checked, penibilite: selected })
          }
        />
      </div>

      {positionAtRisk ? (
        riskyPositions.length > 0 ? (
          <fieldset className="border border-gray-100 rounded-lg overflow-hidden">
            <legend className="sr-only">Facteurs de pénibilité concernés</legend>
            <ul className="divide-y divide-gray-100">
              {riskyPositions.map(({ besttField, name }) => (
                <li key={besttField} className="px-4 py-3 hover:bg-gray-50">
                  <StyledInput
                    type="checkbox"
                    label={name}
                    checked={!!selected[besttField]}
                    onChange={() => togglePenibilite(besttField)}
                  />
                </li>
              ))}
            </ul>
          </fieldset>
        ) : (
          <div className="h-32 bg-gray-100 rounded-lg animate-pulse" />
        )
      ) : null}
    </div>
  );
};

export default TemplateRiskSection;
